import { BattlePassType, deserializeData, MayNull } from '@apeiron/temp'
import { useLazyQuery } from '@apollo/client'
import { battlePassSchema } from '@src/deserialize/yup/battlePass'
import graphql from '@src/graphql/query/getGameBattlePassSchedules'
import { useCallback, useState } from 'react'

const useGetGameBattlePassSchedules = () => {
  const [query, { loading }] = useLazyQuery(graphql)

  const [data, setData] = useState<Response>(null)

  const fetch = useCallback(
    async (request: Request): Promise<Response> => {
      const { userID } = request

      const response = await query({
        variables: {
          userID
        }
      })

      const gameBattlePassSchedules = deserializeData<Response>(
        response,
        battlePassSchema
      )

      setData(gameBattlePassSchedules)

      return gameBattlePassSchedules
    },
    [query]
  )

  return {
    data,
    loading,
    fetch
  }
}

type Request = {
  userID: string
}

type Response = MayNull<BattlePassType[]>

export default useGetGameBattlePassSchedules
